import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import imgButton from "@PUBLIC/P/images/btn/btn_spr.png";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";

const SubTitleWrap = styled.div`
	margin-top: 60px;
`;

const TravelReviewListItem = styled.div`
	display: grid;
	height: 60px;
	border-bottom: 1px solid var(--line-color);
	white-space: nowrap;
	align-items: center;
	grid-template-columns: auto 90px 76px;
	grid-gap: 40px;
	cursor: pointer;
`;

const TravelReviewListInfo = styled.span`
	display: inline-block;
	text-align: right;
`;

const TravelReviewListTitle = styled.h5`
	${Ellipsis(1)};
	display: inline-block;
	max-width: 100%;
	font-size: var(--default-size);
	font-family: "pr-font-medium";
`;

const CategoryTitle = styled.h4<{$line?: boolean}>`
	margin-top: 40px;
	margin-bottom: 20px;
	font-family: "pr-font-medium";
	font-size: var(--medium-size);
	color: var(--emp-color);
	line-height: 1;

	span {
		font-family: "pr-font-bold";
	}

	${props =>
		props.$line &&
		`
		margin-bottom: 0;
		padding-bottom: 20px;
		border-bottom: 1px solid var(--emp-color);
	`}
`;

const WriteRequest = styled.p`
	padding-top: 40px;
	text-align: center;
`;

const Box = styled.div`
	padding: 54px 40px;
	border: 1px solid var(--line-color);
	border-top: none;
	box-sizing: border-box;
`;

const Rating = styled.div`
	position: relative;
	padding-left: 40px;
	font-size: 32px;
	color: #999;
	line-height: 1;

	span {
		font-family: "pr-font-bold";
		font-size: 40px;
		color: var(--emp-color);
	}

	em {
		font-family: "pr-font-bold";
	}

	&:before {
		position: absolute;
		top: 2px;
		left: 0;
		width: 30px;
		height: 30px;
		background: url(${SpriteImage}) -310px 0px / 400px 400px no-repeat;
		content: "";
	}
`;

const CustomerReview = styled.p`
	margin-top: -6px;
	font-family: "pr-font-medium";
	font-size: 18px;
	color: var(--emp-color);
	line-height: 1;

	em {
		color: var(--blue-color);
	}
`;

const TripLabel = styled.span`
	display: flex;
	align-items: center;
	height: 28px;
	padding: 0 20px;
	border-radius: 4px;
	background-color: #fff4d5;
	font-size: var(--basic-size);
	color: var(--emp-color);
`;

const Summary = styled.div`
	padding: 20px 40px;
	margin-top: 18px;
	border-radius: 12px;
	background-color: var(--disabled-color);

	em {
		display: block;
		margin-bottom: 8px;
		font-size: 16px;
		color: var(--emp-color);
		line-height: 1;
	}

	p {
		margin-bottom: 8px;
	}
`;

const Tag = styled.ul`
	display: flex;
	gap: 4px;
	flex-wrap: wrap;

	li {
		font-size: var(--basic-size);
		color: var(--blue-color);
		line-height: 1;

		:before {
			display: inline-block;
			content: "#";
		}
	}
`;

const Highlights = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 20px;
`;

const HighlightItem = styled.li`
	display: flex;
	align-items: center;
	height: 28px;
	padding: 0 20px;
	background-color: var(--disabled-color);
	border-radius: 4px;
	font-size: var(--basic-size);
	box-sizing: border-box;

	span {
		margin-left: 30px;
		font-family: "pr-font-bold";
		color: var(--emp-color);
	}
`;

const Paragraph = styled.div`
	margin-top: 40px;
`;

const SubHeadingWrap = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;

	${CategoryTitle} {
		margin: 0;
	}
`;

const Percent = styled.span`
	padding: 4px 15px;
	margin-left: 10px;
	border-radius: 11px;
	background-color: #e6f2fb;
	font-size: var(--basic-size);
	color: var(--blue-color);
	line-height: 1;

	em {
		font-family: "pr-font-bold";
	}
`;

const ToolTipBtn = styled.button`
	position: relative;
	width: 18px;
	height: 18px;
	margin-left: 5px;
	background: url(${SpriteImage}) 0 -287px / 400px 400px no-repeat;
	font-family: "pr-font-regular";
`;

const ToolTip = styled.div`
	position: absolute;
	top: 30px;
	left: -90px;
	width: 330px;
	padding: 20px;
	border: 1px solid var(--yellow-color);
	background-color: #fff;
	box-sizing: border-box;
	text-align: left;

	p {
		margin-bottom: 6px;
		color: var(--emp-color);
	}
	li {
		font-size: var(--basic-size);
		line-height: 1.72;
		letter-spacing: -0.01em;
	}

	&:before {
		position: absolute;
		display: block;
		top: -5px;
		left: 94px;
		width: 7px;
		height: 7px;
		border-top: 1px solid var(--yellow-color);
		border-left: 1px solid var(--yellow-color);
		transform: rotate(45deg);
		background-color: #fff;
		content: "";
	}
`;

const Gallery = styled.ul`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	grid-gap: 9px;
`;

const GalleryItem = styled.li<{$isList?: boolean}>`
	position: relative;

	a {
		display: block;
		height: 122px;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	${props =>
		props.$isList &&
		`
		cursor: pointer;

		&:before {
			position: absolute;
		    width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.6);
			content: "";
			pointer-events: none;
		}

		&:after {
			position: absolute;
			top: 50%;
			left: 50%;
			color: #fff;
			transform: translate(-50%, -50%);
			content: "더보기";
			pointer-events: none;
		}
	`}
`;

const ReviewGallery = styled.ul`
	display: grid;
	grid-template-columns: repeat(10, 1fr);
	grid-gap: 5px;
	margin-top: 20px;
`;

const ReviewGalleryItem = styled.li`
	position: relative;

	a {
		display: block;
		height: 86px;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}
`;

const ReviewFilter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0 20px;
	margin-top: 40px;
	border-top: 1px solid var(--emp-color);
	border-bottom: 1px solid var(--line-color);
	background-color: var(--disabled-color);
	box-sizing: border-box;
`;

const SelectWrap = styled.div`
	position: relative;
	width: 140px;
	height: 40px;

	ul {
		top: 39px;
	}
`;

const CheckboxWrap = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 10px;
	margin-left: 20px;
`;

const ReviewListItem = styled.li`
	padding: 40px 0;
	border-bottom: 1px solid var(--line-color);
`;

const ScoreWrap = styled.div`
	em {
		margin-left: 10px;
		font-size: 16px;
		font-family: "pr-font-bold";
		color: var(--emp-color);
	}
`;

const ReviewTopBar = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 20px;
	line-height: 1;
`;

const ReviewerProfile = styled.div`
	display: flex;
	gap: 20px;
`;

const UserName = styled.span`
	color: var(--emp-color);
`;

const ProfileDetails = styled.div`
	span:not(:first-child) {
		position: relative;
		padding-left: 13px;
		margin-left: 10px;

		&:before {
			position: absolute;
			top: 50%;
			left: 0;
			display: inline-block;
			width: 3px;
			height: 3px;
			background-color: var(--line-color);
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const Date = styled.time`
	font-size: var(--basic-size);
`;

const ReviewText = styled.p<{isShow?: boolean}>`
	margin: 15px 0 10px;
	${Ellipsis(3)}
	letter-spacing: 0.015em;

	${props =>
		props.isShow &&
		`
		-webkit-line-clamp: initial;
	`}
`;

const FeedbackControls = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 17px;
	line-height: 1;
`;

const RecommendBtnWrap = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	padding-left: 30px;
`;

const RecommendBtn = styled.button`
	position: relative;
	display: block;
	margin-right: 10px;
	background-color: #fff;
	font-family: "pr-font-regular";
	font-size: var(--basic-size);
`;

const RecommendBtnIcon = styled.span<{$isActive?: boolean}>`
	position: absolute;
	top: -2px;
	left: 0;
	display: inline-block;
	width: 21px;
	height: 18px;
	background: transparent url(${imgButton}) 0 -18px / 93px 40px;
	cursor: pointer;

	&:before {
		display: inline-block;
		position: absolute;
		top: -5px;
		left: -5px;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		box-shadow: inset 0 0 0 50px var(--blue-color);
		opacity: 0;
		transform: scale(0);
		transition: box-shadow 0.3s 0.2s, opacity 0.3s, transform 0.3s;
		content: "";
	}

	${props =>
		props.$isActive &&
		`
		background: transparent url(${imgButton}) -22px -18px / 93px 40px;
		animation: change .5s forwards;

		&:before {
			box-shadow: inset 0 0 0 0 var(--blue-color);
			opacity: 1;
			transform: scale(1);
		}
	`}

	@keyframes change {
		50% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}
`;

const LikeCount = styled.span`
	font-size: var(--basic-size);
`;

const ReportBtn = styled.button`
	background-color: transparent;
	font-size: var(--basic-size);
	text-decoration: underline;
`;

const TravelReviewWrap = styled.div`
	margin-top: 60px;
`;

const TravelReviewList = styled.ul``;

const LoadMoreBtn = styled.button`
	width: 100%;
	margin-top: 40px;
	background-color: #fff;
	font-family: "pr-font-regular";
	em {
		position: relative;
		display: inline-block;
		padding-right: 22px;
		&:after {
			display: inline-block;
			position: absolute;
			top: 3px;
			right: 2px;
			width: 7px;
			height: 7px;
			border-top: 1px solid var(--default-color);
			border-left: 1px solid var(--default-color);
			transform: rotate(225deg);
			content: "";
		}
	}
`;

export {
	TravelReviewListItem,
	TravelReviewListTitle,
	TravelReviewListInfo,
	CategoryTitle,
	WriteRequest,
	Box,
	Rating,
	CustomerReview,
	Summary,
	Tag,
	TripLabel,
	Highlights,
	HighlightItem,
	Paragraph,
	Percent,
	SubHeadingWrap,
	ToolTipBtn,
	ToolTip,
	Gallery,
	GalleryItem,
	SelectWrap,
	ReviewFilter,
	CheckboxWrap,
	ScoreWrap,
	ReviewListItem,
	ReviewTopBar,
	ReviewerProfile,
	UserName,
	ProfileDetails,
	Date,
	ReviewText,
	RecommendBtn,
	FeedbackControls,
	LikeCount,
	ReportBtn,
	RecommendBtnWrap,
	RecommendBtnIcon,
	TravelReviewWrap,
	TravelReviewList,
	LoadMoreBtn,
	ReviewGallery,
	ReviewGalleryItem,
	SubTitleWrap,
};
